import { Injectable } from '@angular/core';
import MobileDetect from 'mobile-detect';

@Injectable({
  providedIn: 'root',
})
export class BrowserService {
  public doubleInput = false;

  constructor() {
    const mobileInstance = new MobileDetect(window.navigator.userAgent);
    this.doubleInput =
      mobileInstance.mobile() !== null &&
      mobileInstance.is('Chrome') &&
      (mobileInstance.is('iPhone') || mobileInstance.is('Opera'));
  }
}
